module.exports = __webpack_public_path__ + "img/posologie-if-hamid.7810f19e.png";